import { getErrorMessage } from "src/utils/form.utils";
import { Controller } from "react-hook-form";
import { IFormField } from "src/types/form.types";


type Props = IFormField & {
    errors: any;
    control: any;
};
export const TextField = ({
    label,
    name,
    type,
    placeholder,
    disabled,
    autoFocus,
    control,
    errors,
}: Props) => {
    return (
        <>
            <label htmlFor={name} className="custom-label-field">{label}</label>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <input
                        type={type}
                        {...field}
                        placeholder={placeholder}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        name={name}
                        id={name}
                        className={`custom-input ${errors[name] ? "border-red-500" : ""}`}
                    >
                    </input>
                )}
            />
            {errors[name] && <p className={`mt-4 text-left text-sm ${errors[name] ? "text-red-500" : ""
                }`}>
                {getErrorMessage(errors[name].message, label)}
            </p>
            }
        </>
    )
};

